import * as React from 'react';
import { addLocale } from 'primereact/api';
import { useDispatch } from 'react-redux';

import { AlertComponent } from "./components/base/AlertComponent";
import { AppRouting } from "./routing/AppRouting";
import { commonConstant } from './helpers/constants';
import { getDictionariesContext } from './store/reducers/DictionariesContext';
import { Header } from "./components/base/Header";
import { ProgressBarComponent } from "./components/base/ProgressBarComponent";
import { services } from './services';
import { useBackgroundPromiseEffect } from './helpers/hooks/useBackgroundPromiseEffect';
import { ConfirmDialog } from 'primereact/confirmdialog';


const registrationInstructionUrl = 'https://cpda.x5.ru/files/guides/cpda-260720.pdf';

const MigrationNotice: React.FC = () => (
  <div className="migration-notice" role="status" aria-label="Уведомление о переезде">
    <div className="migration-notice__content">
      <i className="fa-solid fa-triangle-exclamation migration-notice__icon" aria-hidden="true"></i>
      <span className="migration-notice__text">
        Уважаемые коллеги, в июле планируется переезд на новый адрес -{' '}
        <a
          className="migration-notice__link"
          href="https://cpda.x5.ru"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://cpda.x5.ru
        </a>
        {' '}Регистрация открыта, инструкция обновлена{' '}
        <a
          className="migration-notice__link"
          href={registrationInstructionUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Инструкция от 20.07
        </a>
      </span>
    </div>
  </div>
);

export const App: React.FC = () => {
  const dispatch = useDispatch();
  useBackgroundPromiseEffect(() => services.dictionariesService.get(), (data) => dispatch(getDictionariesContext(data)), []);

  addLocale("ru", commonConstant.calendar);

  return (
    <div className="layout">
      <Header />
      <ProgressBarComponent />
      <ConfirmDialog />
      <AlertComponent />
      <div className="px-1">
        <AppRouting />
      </div>
    </div>
  );
}
